import { MetricConverter } from './helpers';
import { ConvertArgs } from './types';

const TemperatureCoefficientUnits = ['%/°C', '%/K'] as const;

type TTemperatureCoefficientUnit = (typeof TemperatureCoefficientUnits)[number];

class TemperatureCoefficientConverter extends MetricConverter<TTemperatureCoefficientUnit, '%/°C'> {
    baseUnit = '%/°C' as const;
    units = TemperatureCoefficientUnits;

    toBase = ({ value }: { value: number; from: TTemperatureCoefficientUnit }): { value: number; unit: '%/°C' } => ({
        value,
        unit: this.baseUnit,
    });

    convert = <TUnit extends TTemperatureCoefficientUnit>({
        value,
        to,
    }: ConvertArgs<TTemperatureCoefficientUnit, TUnit>): { value: number; unit: TUnit } => ({ value, unit: to });
}

export const temperatureCoefficientConverter = new TemperatureCoefficientConverter();
